module.exports = __webpack_public_path__ + "static/media/jared.42ca66dd.jpeg";